import { RESELLER, isInternic } from './brand'
import { host } from './host'

const resellerApiSite = isInternic ? 'internic.ca' : 'rebel.com'

const createEndpoint = endpoint => `https://${host}${endpoint}`

const createEndpoints = (arr, path) =>
  arr.reduce((acc, el) => {
    acc[el] = createEndpoint(`${path}/${el}`)
    return acc
  }, {})

const SKYWALKER_ENDPOINTS = {
  openExchange: 'open-exchange/',
  domains: 'domains/',
  log: 'log/',
}

const buildSkywalkerEndpoint = endpoint => {
  const endpointProd = {
    path: `https://api.${resellerApiSite}/${endpoint}`,
  }
  const endpointDev = {
    path: `https://dev.api.${resellerApiSite}/${endpoint}`,
  }
  const endpointLocal = {
    path: `http://localhost:3001/${endpoint}`,
  }

  const { path } =
    // eslint-disable-next-line no-undef
    (__LOCAL__ && endpointLocal) ||
    (__DEV__ && endpointDev) ||
    (__PROD__ && endpointProd)

  return path
}

const getUserSunshineJWTEndpoint = () => {
  const endpoint = `api/user/sunshine/jwt`

  const userSunshineEndpointProd = {
    path: `https://www.${resellerApiSite}/${endpoint}`,
  }

  const userSunshineEndpointDev = {
    path: `https://dev.${resellerApiSite}/${endpoint}`,
  }

  const userSunshineEndpointLocal = {
    path: `https://local.${resellerApiSite}/${endpoint}`,
  }

  const { path } =
    // eslint-disable-next-line no-undef
    (__LOCAL__ && userSunshineEndpointLocal) ||
    (__DEV__ && userSunshineEndpointDev) ||
    (__PROD__ && userSunshineEndpointProd)

  return path
}

const getOXaccounts = () => createEndpoint('/api/openexchange')

const getOXAddToCart = () => createEndpoint('/api/openexchange/add-to-cart')

const getPrivacyProtectionEndpoint = () => {
  const privacyProtectionEndpointProd = {
    privacyProtectionEndpoint: `https://www.${RESELLER}/api/domains/privacyprotection`,
  }
  const privacyProtectionEndpointDev = {
    privacyProtectionEndpoint: `https://dev.${RESELLER}/api/domains/privacyprotection`,
  }
  const privacyProtectionEndpointLocal = {
    privacyProtectionEndpoint: `http://local.${RESELLER}/api/domains/privacyprotection`,
  }

  const { privacyProtectionEndpoint } =
    // eslint-disable-next-line no-undef
    (__LOCAL__ && privacyProtectionEndpointLocal) ||
    (__DEV__ && privacyProtectionEndpointDev) ||
    (__PROD__ && privacyProtectionEndpointProd)

  return privacyProtectionEndpoint
}

const getExpiryProtectionEndpoint = () => {
  const expiryProtectionEndpointProd = {
    expiryProtectionEndpoint: `https://www.${RESELLER}/api/domains/expiryprotection`,
  }
  const expiryProtectionEndpointDev = {
    expiryProtectionEndpoint: `https://dev.${RESELLER}/api/domains/expiryprotection`,
  }
  const expiryProtectionEndpointLocal = {
    expiryProtectionEndpoint: `http://local.${RESELLER}/api/domains/expiryprotection`,
  }

  const { expiryProtectionEndpoint } =
    // eslint-disable-next-line no-undef
    (__LOCAL__ && expiryProtectionEndpointLocal) ||
    (__DEV__ && expiryProtectionEndpointDev) ||
    (__PROD__ && expiryProtectionEndpointProd)

  return expiryProtectionEndpoint
}

const getOwnershipProtectionEndpoint = () => {
  const ownershipProtectionEndpointProd = {
    ownershipProtectionEndpoint: `https://www.${RESELLER}/api/domains/ownershipprotection`,
  }
  const ownershipProtectionEndpointDev = {
    ownershipProtectionEndpoint: `https://dev.${RESELLER}/api/domains/ownershipprotection`,
  }
  const ownershipProtectionEndpointLocal = {
    ownershipProtectionEndpoint: `http://local.${RESELLER}/api/domains/ownershipprotection`,
  }

  const { ownershipProtectionEndpoint } =
    // eslint-disable-next-line no-undef
    (__LOCAL__ && ownershipProtectionEndpointLocal) ||
    (__DEV__ && ownershipProtectionEndpointDev) ||
    (__PROD__ && ownershipProtectionEndpointProd)

  return ownershipProtectionEndpoint
}

const getMarketgooLoginEndpoint = domainId => {
  const marketgooLoginEndpointProd = {
    marketgooLoginEndpoint: `https://www.rebel.com/api/domains/${domainId}/marketgoologin`,
  }
  const marketgooLoginEndpointDev = {
    marketgooLoginEndpoint: `https://dev.rebel.com/api/domains/${domainId}/marketgoologin`,
  }
  const marketgooLoginEndpointLocal = {
    marketgooLoginEndpoint: `http://local.rebel.com/api/domains/${domainId}/marketgoologin`,
  }

  const { marketgooLoginEndpoint } =
    // eslint-disable-next-line no-undef
    (__LOCAL__ && marketgooLoginEndpointLocal) ||
    (__DEV__ && marketgooLoginEndpointDev) ||
    (__PROD__ && marketgooLoginEndpointProd)

  return marketgooLoginEndpoint
}

const getDomainRecoveryEndpoint = domainId =>
  createEndpoint(`/api/domains/${domainId}/recover`)

const getDynamicPriceEndpoint = itemcodes => {
  const dynamicePriceEndpointProd = {
    dynamicePriceEndpoint: `https://api.${resellerApiSite}/price/static/itemcodes?itemcodes=${itemcodes}`,
  }
  const dynamicePriceEndpointDev = {
    dynamicePriceEndpoint: `https://dev.api.${resellerApiSite}/price/static/itemcodes?itemcodes=${itemcodes}`,
  }
  const dynamicePriceEndpointLocal = {
    dynamicePriceEndpoint: `http://localhost:3001/price/static/itemcodes?itemcodes=${itemcodes}`,
  }

  const { dynamicePriceEndpoint } =
    // eslint-disable-next-line no-undef
    (__LOCAL__ && dynamicePriceEndpointLocal) ||
    (__DEV__ && dynamicePriceEndpointDev) ||
    (__PROD__ && dynamicePriceEndpointProd)

  return dynamicePriceEndpoint
}

// ========= USER =========

const user = [
  'creditcard',
  'info',
  'social',
  'logout',
  'auth',
  'create',
  'comredirecturl',
  'sso',
  'currency',
  'setcontact',
  'token',
  'current',
]

// creates //${host}/api/user/${userEndpoint}
const userEndpoints = createEndpoints(user, '/api/user')
userEndpoints.passwordReset = createEndpoint('/api/password/reset')
userEndpoints.passwordSet = createEndpoint('/api/password/set')
userEndpoints.activationValidate = createEndpoint('/api/activation/validate')
userEndpoints.userAccessToken = createEndpoint(`/api/user/token`)
userEndpoints.error = createEndpoint('/api/user/error-logger')
userEndpoints.defaultContact = createEndpoint('/api/user/defaultcontact')

// ========= CREDIT CARD =========

const creditCardEndpoints = {}

creditCardEndpoints.card = createEndpoint('/api/creditcard')
creditCardEndpoints.default = createEndpoint('/api/creditcard/default')
creditCardEndpoints.backup = createEndpoint('/api/creditcard/backup')

// ========= QUICK RENEW ========

const quickRenewEndpoints = {}

quickRenewEndpoints.summary = domainName =>
  createEndpoint(`/api/chargebee/quick-renew/${domainName}/summary`)

quickRenewEndpoints.process = (domainName, chargebeeToken) =>
  createEndpoint(
    `/api/chargebee/quick-renew/${domainName}/process/${chargebeeToken}`
  )

// ========= CONTACT ==============
const contactEndpoints = {}
contactEndpoints.contact = createEndpoint('/api/contacts')
contactEndpoints.deleteById = createEndpoint('/api/deletecontacts')
contactEndpoints.primaryContact = createEndpoint('/api/user/setcontact')

const getTLDOptionsEndpoint = () => createEndpoint('/api/options/extrainfo')

const addInfoRequiredProd = {
  addInfoRequiredEndpoint: `https://www.${RESELLER}/api/domaintransfer/DoDomainsRequireAdditionalInfo`,
}
const addInfoRequiredDev = {
  addInfoRequiredEndpoint: `https://dev.${RESELLER}/api/domaintransfer/DoDomainsRequireAdditionalInfo`,
}
const addInfoRequiredLocal = {
  addInfoRequiredEndpoint: `https://local.${RESELLER}/api/domaintransfer/DoDomainsRequireAdditionalInfo`,
}

const { addInfoRequiredEndpoint } =
  // eslint-disable-next-line no-undef
  (__LOCAL__ && addInfoRequiredLocal) ||
  (__DEV__ && addInfoRequiredDev) ||
  (__PROD__ && addInfoRequiredProd)

// ========= EMAIL SIGNUP =========

const marketingEndpoint =
  __DEV__ || __LOCAL__
    ? `https://dev.api.rebel.com`
    : 'https://api.mktg.rebel.com'

const emailSignup = __DEV__
  ? `${marketingEndpoint}/automation/email/sign-up`
  : `${marketingEndpoint}/automation/email/sign-up`

const mfaEndpointProd = {
  mfaEndpoint: `https://api.rebel.com/2fa`,
}
const mfaEndpointDev = {
  mfaEndpoint: `https://dev.api.rebel.com/2fa`,
}
const mfaEndpointLocal = {
  mfaEndpoint: `http://localhost:3001/2fa`,
}

const { mfaEndpoint } =
  // eslint-disable-next-line no-undef
  (__LOCAL__ && mfaEndpointLocal) ||
  (__DEV__ && mfaEndpointDev) ||
  (__PROD__ && mfaEndpointProd)

const addBulkMarketgooEndpoint = createEndpoint('/api/order/add-bulk-marketgoo')
const addBulkSecurityEndpoint = createEndpoint('/api/order/add-bulk-security')
const removeBulkSecurityEndpoint = createEndpoint(
  '/api/order/remove-bulk-security'
)
const bulkSecurityEndpoints = {
  add: addBulkSecurityEndpoint,
  remove: removeBulkSecurityEndpoint,
}

const supportRequestEndpoint = `${marketingEndpoint}/web-form/order-support-request`

const notificationProd = {
  notificationEndpoint: `https://api.rebel.com/notification`,
}
const notificationDev = {
  notificationEndpoint: `https://dev.api.rebel.com/notification`,
}
const notificationLocal = {
  notificationEndpoint: `http://localhost:3002/notification`,
}

const { notificationEndpoint } =
  // eslint-disable-next-line no-undef
  (__LOCAL__ && notificationLocal) ||
  (__DEV__ && notificationDev) ||
  (__PROD__ && notificationProd)

const googleWorkspaceProd = {
  googleWorkspaceEndpoint: `https://api.rebel.com/google-workspace`,
}
const googleWorkspaceDev = {
  googleWorkspaceEndpoint: `https://dev.api.rebel.com/google-workspace`,
}
const googleWorkspaceLocal = {
  googleWorkspaceEndpoint: `http://localhost:3001/google-workspace`,
}

const { googleWorkspaceEndpoint } =
  // eslint-disable-next-line no-undef
  (__LOCAL__ && googleWorkspaceLocal) ||
  (__DEV__ && googleWorkspaceDev) ||
  (__PROD__ && googleWorkspaceProd)

// ========= Prices endpoint  =========
const pricesEndpoint = createEndpoint('/api/price/static/all')

const pricesTLDsProd = {
  pricesTLDsEndpoint: `https://api.${resellerApiSite}/price/tlds/${resellerApiSite}`,
}
const pricesTLDsDev = {
  pricesTLDsEndpoint: `https://dev.api.${resellerApiSite}/price/tlds/${resellerApiSite}`,
}
const pricesTLDsLocal = {
  pricesTLDsEndpoint: `http://localhost:3001/price/tlds/${resellerApiSite}`,
}

const { pricesTLDsEndpoint } =
  // eslint-disable-next-line no-undef
  (__LOCAL__ && pricesTLDsLocal) ||
  (__DEV__ && pricesTLDsDev) ||
  (__PROD__ && pricesTLDsProd)

const pricesAddonsProd = {
  pricesAddonsEndpoint: `https://api.${resellerApiSite}/price/items/${resellerApiSite}`,
}
const pricesAddonsDev = {
  pricesAddonsEndpoint: `https://dev.api.${resellerApiSite}/price/items/${resellerApiSite}`,
}
const pricesAddonsLocal = {
  pricesAddonsEndpoint: `https://dev.api.${resellerApiSite}/price/items/${resellerApiSite}`,
}

const { pricesAddonsEndpoint } =
  // eslint-disable-next-line no-undef
  (__LOCAL__ && pricesAddonsLocal) ||
  (__DEV__ && pricesAddonsDev) ||
  (__PROD__ && pricesAddonsProd)

// ========= ORDER =========

const order = ['count']

// creates //${host}/api/order/${orderEndpoint}
const orderEndpoints = createEndpoints(order, '/api/order')
const localOrderEndpoint = 'http://localhost:4000/order'
const devOrderEndpoint = `https://dev.api.${resellerApiSite}/order`
const prodApiEndpoint = `https://api.${resellerApiSite}/order`
orderEndpoints.get =
  (__LOCAL__ && localOrderEndpoint) ||
  (__DEV__ && devOrderEndpoint) ||
  (__PROD__ && prodApiEndpoint)
orderEndpoints.addToCart = ({ domain, packageId, type }) =>
  createEndpoint(`/api/${type}/add-to-cart/${domain}/${packageId}`)

const localGraphAPI = 'http://localhost:3000/graphql/'
const devGraphAPI = `https://dev.api.${resellerApiSite}/graphql`
const prodGraphAPI = `https://api.${resellerApiSite}/graphql`
const graphQLEndpoint =
  (__LOCAL__ && localGraphAPI) ||
  (__DEV__ && devGraphAPI) ||
  (__PROD__ && prodGraphAPI)

const shoppingCartEndpoint = createEndpoint('/MyAccount/ShoppingCart.aspx')

const payPalUrl = '//www.paypalobjects.com/api/checkout.js'
const countriesEndpoint = createEndpoint('/api/options/countries')

// ========= Email Setup endpoint  =========

const emailSetupEndpoint = `https://api.${resellerApiSite}/email-assistant`

// ========= My Account Domains endpoint  =========
const localDomains = `https://local.${RESELLER}/api/user/domains/`
const devDomains = `https://dev.${RESELLER}/api/user/domains/`
const prodDomains = `https://www.${RESELLER}/api/user/domains/`
const accountDomains =
  (__LOCAL__ && localDomains) ||
  (__DEV__ && devDomains) ||
  (__PROD__ && prodDomains)

// ========= Simple email login =========
const localSimpleEmailLoginLink = subscriptionId =>
  `http://local.rebel.com/api/subscription/hosting/${subscriptionId}/loginlink`
const devSimpleEmailLoginLink = subscriptionId =>
  `https://dev.rebel.com/api/subscription/hosting/${subscriptionId}/loginlink`
const prodSimpleEmailLoginLink = subscriptionId =>
  `https://www.rebel.com/api/subscription/hosting/${subscriptionId}/loginlink`

const simpleEmailLoginLink =
  (__LOCAL__ && localSimpleEmailLoginLink) ||
  (__DEV__ && devSimpleEmailLoginLink) ||
  (__PROD__ && prodSimpleEmailLoginLink)

const NicSupportDomain = `https://support.internic.ca`
const RebelSupportDomain = `https://support.rebel.com`
const SupportDomain = isInternic ? NicSupportDomain : RebelSupportDomain

const createSupportArticleEndpoint = (nicArticleID, rebelArticleID) => {
  if (isInternic) {
    return `${SupportDomain}/hc/en-us/articles/${nicArticleID}`
  }
  return `${SupportDomain}/hc/en-us/articles/${rebelArticleID}`
}

export {
  SKYWALKER_ENDPOINTS,
  getOXaccounts,
  getOXAddToCart,
  addInfoRequiredEndpoint,
  bulkSecurityEndpoints,
  buildSkywalkerEndpoint,
  contactEndpoints,
  countriesEndpoint,
  createEndpoint,
  creditCardEndpoints,
  emailSignup,
  emailSetupEndpoint,
  getTLDOptionsEndpoint,
  googleWorkspaceEndpoint,
  graphQLEndpoint,
  marketingEndpoint,
  mfaEndpoint,
  notificationEndpoint,
  orderEndpoints,
  pricesEndpoint,
  pricesTLDsEndpoint,
  pricesAddonsEndpoint,
  shoppingCartEndpoint,
  simpleEmailLoginLink,
  supportRequestEndpoint,
  userEndpoints,
  payPalUrl,
  accountDomains,
  getDynamicPriceEndpoint,
  getPrivacyProtectionEndpoint,
  getExpiryProtectionEndpoint,
  getUserSunshineJWTEndpoint,
  getOwnershipProtectionEndpoint,
  getMarketgooLoginEndpoint,
  createSupportArticleEndpoint,
  getDomainRecoveryEndpoint,
  addBulkMarketgooEndpoint,
  quickRenewEndpoints,
}
